/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListJobsSortBy } from './listJobsSortBy';
import type { ListJobsSortDir } from './listJobsSortDir';
import type { ListJobsStatus } from './listJobsStatus';
import type { ListJobsStatusNot } from './listJobsStatusNot';

export type ListJobsParams = {
project_id?: string | null;
search?: string | null;
status?: ListJobsStatus;
status_not?: ListJobsStatusNot;
manager_id?: string | null;
manager_id_not?: string | null;
sort_by?: ListJobsSortBy;
sort_dir?: ListJobsSortDir;
include_archived?: boolean;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
cursor?: string | null;
};
